import { SxProps, Theme } from '@mui/material';
import Chip from '@mui/material/Chip';
import { t } from 'i18next';

import { FlexColumn } from '~components/Order/ordersDispatchStyledComponents';
import { Ticket } from '~hooks/useTickets/models';

interface StatusColumnProps {
  ticket: Ticket;
  sx?: SxProps<Theme>;
}

export default function StatusColumn({ ticket, sx }: StatusColumnProps) {
  const isMatched = Boolean(ticket.jobId);

  return (
    <FlexColumn sx={sx}>
      <Chip
        label={
          isMatched
            ? t('dispatch.tickets_table.matched')
            : t('dispatch.tickets_table.not_matched')
        }
        size="small"
        color={isMatched ? 'success' : 'error'}
        sx={{ width: 'fit-content', px: 1 }}
      />
    </FlexColumn>
  );
}
